import { getReportYearData } from '../../api/yearReport';

const state = {
  reportData: {
    bendingCount: 0, // 压弯次数
    bindTime: '', // 绑车日期
    createTime: '', // 生成时间
    downRideTime: '', // 最晚骑车时间
    maxDistance: 0, // 最长骑行距离KM
    maxDistanceLabel: '', // 最大里程标签
    maxDistanceTime: '', // 最长骑行的时间
    maxRideCount: 0, // 单天最大骑行数量
    maxRideCountTime: '', // 骑行次数最多的那天
    maxSpeed: '', // 最大速度km/h
    maxSpeedLabel: '', // 最大速度标签
    maxSpeedTime: '', // 最大速度的时间
    rideDays: 0, // 骑行的天数
    throughCityCount: 0, // 途经城市的数量
    throughCityNameList: [], // 途径的城市名称
    totalDistance: 0, // 总里程km
    upRideTime: '', // 最早骑车时间
    useFrequencyLabel: '', // 使用系数标签
  },
  agreementForm: {
    isAgreement: false,
  },
};
const mutations = {
  GET_REPORT_DATA(states, reportData) {
    state.reportData = reportData;
  },
  AGREEMENT_UPDATE(states, value) {
    state.agreementForm = value;
  },
};
const actions = {
  async getData({ commit }) {
    const resData = await getReportYearData({});
    if (resData.code) {
      commit('GET_REPORT_DATA', {});
    } else {
      commit('GET_REPORT_DATA', resData.data);
    }
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
